import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelVestingSchedule from "@/models/BaseModelVestingSchedule.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";

export const UnitClassConfig = {
	grid: {
		gridId:'ProgramClassInfoGrid',
		height: 0,
		groupable : false,
		editable : true,
		selectable : true,
		filterable : false,
		resizable : false,
		noRecords : true,
		reorderable : false,
		columnMenu : false,
		sortable : false,
		pageable:false,
		edit:false,
		delete: true,
		save: true,
		sort: [{ field: "UnitClass", dir: "asc" }]
	},
	list: BaseModelUnitClass.list,
	columns: BaseModelUnitClass.columns
}

export const VestingScheduleConfig = {
	grid: {
		gridId:'ProgramVestingScheduleGrid',
		height: 0,
		groupable : false,
		editable : true,
		selectable : true,
		filterable : false,
		resizable : false,
		noRecords : true,
		reorderable : false,
		columnMenu : false,
		sortable : false,
		pageable:false,
		edit:false,
		delete: true,
		sort: [
			{ field: "UnitClass", dir: "asc" },
			{ field: "UnitType", dir: "asc" },
			{ field: "Year", dir: "asc" },
		]
	},
	list: BaseModelVestingSchedule.list,
	columns: BaseModelVestingSchedule.columns
}

export const InvestmentConfig ={
		list: BaseModelInvestment.list,
		columns: BaseModelInvestment.columns
}
